/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Ornate_Alpaca_FosterInputs */

const fr_agent_ornate_alpaca_foster = /** @type {(inputs: Agent_Ornate_Alpaca_FosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta hauteur max`)
};

/**

* @param {Agent_Ornate_Alpaca_FosterInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const agent_ornate_alpaca_foster = /** @type {((inputs?: Agent_Ornate_Alpaca_FosterInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Ornate_Alpaca_FosterInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_agent_ornate_alpaca_foster(inputs)
});